import React from 'react';

import { ModalProps } from '../../../../components/Modal';
import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';

import { SimpleModal } from '../../../../components/SimpleModal';

export type SystemUnavailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const LateAppointmentModal: React.FC<SystemUnavailableProps> = ({ visible, onClose }) => {
  return (
    <SimpleModal
      name="late-appointment"
      visible={visible}
      onClose={onClose}
      title="Agendamento de retorno indisponível"
      subtitle='
        <p className="info1">
          O prazo para agendamento das consultas de retorno expirou. Para mais informações, entre em contato com a nossa central de atendimento no número <a className="phone-link" href="tel:01121511233">(11) 2151-1233</a>.
        </p>
        <br />
        <p className="info2">Atendimento disponível de segunda a sexta, das 7:00 às 19:00, sábado das 7:00 às 13:00, exceto feriados.</p>
      '
      mainIcon={<WarningModal />}
    />
  );
};
